import React, { useState, useEffect } from 'react';
import { Card, Avatar } from '@material-ui/core';
import Progress from '@common/Progress';
import { observer } from 'mobx-react';
import Store from '@data/Store';
import './GSDCard.css';
import { Tooltip } from 'react-tippy';
import Notify from '../../TicketManagement/Notification';
import Tag from '@common/Tag';

export default observer((props) => {
  let {
    children,
    progress = true,
    src,
    ticket,
    title,
    indicator,
    date,
    version,
    current,
    progressColor,
    onClick,
    name_user,
    user,
    users,
  } = props;
  let { language, socket, new_msg_notifications } = Store;
  let { TICKET_PRIORITY } = language;
  let aprovadores = '';

  if (ticket.chief != null) {
    ticket.chief.map((y) => {
      users
        .filter((h) => h.id_user == y)
        .map((u) => {
          aprovadores = aprovadores + u.name + ' ';
        });
    });
  }
  return (
    <Card
      className="GSDCard content-min w-100"
      onClick={onClick}
      style={{
        borderColor: 'var(--warning)',
        background: user == ticket.fk_id_user ? '#d2d9db !important;' : '',
      }}
    >
      <div className="d-flex align-items-start justify-content-between">
        <p className="ellipsis-line camp-2">{title}</p>

        <Tag
          label={
            indicator == 1
              ? TICKET_PRIORITY.HIGH
              : indicator == 2
              ? TICKET_PRIORITY.MEDIUM
              : indicator == 3
              ? TICKET_PRIORITY.SMALL
              : indicator == 4
              ? TICKET_PRIORITY.CRITICAL
              : null
          }
          color={
            indicator == 1
              ? '#F05E02'
              : indicator == 3
              ? '#02cbf0'
              : indicator == 4
              ? 'var(--red)'
              : null
          }
        />
      </div>
      <div>
        <div className="d-flex justify-content-end">
          {ticket.approval == true ? (
            <Tooltip
              html={`${language.APPROVER} ${aprovadores}`}
              position="left"
              theme="dark"
              arrow
            >
              <i
                class="fas fa-user-tie"
                style={{
                  marginRight: '8px',
                  color: 'var(--primary)',
                }}
              ></i>
            </Tooltip>
          ) : null}
          {user == ticket.fk_id_user ? (
            <Tooltip
              html={language.YOU_ARE_CALLER}
              position="left"
              theme="dark"
              arrow
            >
              <i
                class="fas fa-user-check"
                style={{ color: 'rgb(250, 150, 51)' }}
              ></i>
            </Tooltip>
          ) : null}
          {(ticket.observers || []).includes(user) ? (
            <Tooltip
              html={language.YOU_HAVE_BEEN_ADDED_OBSERVER}
              position="left"
              theme="dark"
              arrow
            >
              <i
                class="fas fa-binoculars"
                style={{ color: 'rgb(250, 150, 51)' }}
              ></i>
            </Tooltip>
          ) : null}

          {ticket.status == 'Reject' ? (
            <Tooltip
              html={
                <p
                  style={{ color: 'white' }}
                  dangerouslySetInnerHTML={{
                    __html: `${language.CALL_REJECTED} ${ticket.reason}`,
                  }}
                />
              }
              position="left"
              theme="dark"
              arrow
            >
              <i
                class="fas fa-times-circle"
                style={{ marginLeft: '5px', color: 'var(--danger)' }}
              ></i>
            </Tooltip>
          ) : null}
          <Notify msn={new_msg_notifications} t={ticket} socket={socket} />
        </div>
        <Progress current={current} background={progressColor} />
        <div className="content-info d-flex align-items-center justify-content-between mt-2">
          <div className="d-flex align-items-center item-1">
            <Tooltip
              html={
                ticket.id_request ? (
                  <div style={{ color: '#fff', fontSize: 15 }}>
                    <strong>
                      {language.REQUESTER}: {ticket.name}
                    </strong>
                    <br></br>
                    <strong>
                      {language.COMPANY}: {ticket.name_company}
                    </strong>
                  </div>
                ) : (
                  <div style={{ color: '#fff', fontSize: 15 }}>
                    <strong>
                      {language.SERVICE_TECH}: {name_user}
                    </strong>
                    <br></br>
                    <strong>
                      {language.REQUESTER}: {ticket.grid_user}
                    </strong>
                    <br></br>
                    <strong>
                      {language.COMPANY}: {ticket.grid_company}
                    </strong>
                  </div>
                )
              }
              position="left"
              theme="dark"
              arrow
            >
              <Avatar className="avatar mr-1">
                {(name_user || '').slice(0, 2)}
              </Avatar>
            </Tooltip>
            <span className="ellipsis">{name_user}</span>
          </div>
          <div className="d-flex align-items-center item-2">
            <i className="fas fa-calendar-day mr-1" />
            <span>{date}</span>
          </div>
          <span>{version}</span>
        </div>
      </div>
    </Card>
  );
});
